/** Connect the supplied, isolated KUBIS section to the host router and preferences. */
export function initializeCollaboration(app) {
  const section = document.querySelector('kubis-spolupraca');
  if (!section) return;
  const header = document.querySelector('header');
  const desktop = window.matchMedia('(min-width: 981px)');

  function syncPreferences() {
    section.setAttribute('lang', document.documentElement.lang === 'en' ? 'en' : 'sk');
    if (document.body.classList.contains('dark-mode')) section.setAttribute('theme', 'dark');
    else section.removeAttribute('theme');
  }

  function syncHeader() {
    const offset = desktop.matches ? 0 : Math.max(0, header?.getBoundingClientRect().height || 0);
    const value = `${Math.round(offset)}px`;
    if (section.getAttribute('header-offset') !== value) section.setAttribute('header-offset', value);
  }

  section.addEventListener('kubis-contact', (event) => {
    event.preventDefault();
    app.navigation.proposalContact('private');
  });
  const themeObserver = new MutationObserver(syncPreferences);
  themeObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  const languageObserver = new MutationObserver(syncPreferences);
  languageObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  const headerObserver = new ResizeObserver(syncHeader);
  if (header) headerObserver.observe(header, { box: 'border-box' });
  desktop.addEventListener('change', syncHeader);
  syncPreferences();
  syncHeader();
}
